import { loadStripe } from "@stripe/stripe-js";
import CONFIG from "../model/TSConfig";

const stripePromise = loadStripe(CONFIG.stripePublicKey);
export default stripePromise;
